import React, { useEffect } from 'react';
import { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import { useTopicInputDefaultValue } from '../../hooks/init';
import { keywordsReplaceText } from '../KeyWordsSelect/utils';
import { Form, Justify } from 'tea-component';
import { useRequestFontWebConfig } from '@op/hooks/useFrontWebConfig';
import TagList from '../../components/TagList';
import useLanguage from '@op/hooks/useLanguage';
import AutoTextAreaBox from '../../components/AutoTextAreaBox';
import { DefaultImg } from '@op/constants/defaultImg';
import { getKeywordTopicPalaceholder } from '../../utils/keyword';

export default function KeywordTopicPreview({
  gameInfo,
  onChange,
  defaultValue,
  filterValue,
  oriDefaultFilter,
  backOriDefaultValue,
  lang,
}: SingleCommonType) {
  const { value, setValue } = useTopicInputDefaultValue({
    defaultValue,
    filterValue,
  });

  const { formatMessage, isEn } = useLanguage();

  useEffect(() => {
    onChange?.(
      'topic_preview',
      commonBackInfo({ query: value }, { query: value }),
    );
  }, [value]);

  // const { keyword_topic_shortcut } = useRequestFontWebConfig({
  //   keys: [{ key: 'keyword_topic_shortcut', defaultValue: [] }],
  //   gameInfo,
  // });

  return (
    <div className={'keyword-preview-wrapper'}>
      <Form.Item>
        <Justify
          className="dbo-analysis-url-row"
          top
          left={
            <div className="dbo-analysis-url-row-figure">
              <img src={DefaultImg.AI}></img>
              {formatMessage('Natural Language Search')}
            </div>
          }
        // right={
        //   <TagList
        //     list={keyword_topic_shortcut}
        //     isEn={isEn}
        //     setValue={setValue}
        //   ></TagList>
        // }
        />

        <AutoTextAreaBox
          value={value}
          replaceText={keywordsReplaceText}
          minHeight={152}
          hasTips={false}
          disabled
          setValue={setValue}
          placeholder={getKeywordTopicPalaceholder(formatMessage)}
        ></AutoTextAreaBox>
      </Form.Item>
    </div>
  );
}
